export enum ClientRequestFilterKeys {
  PRODUCT_IDS = "clientRequestFilterProductIds",
  STATUS = "clientRequestStatus"
}
